export function formatRelativeTime(timestamp) {
  const now = new Date()
  const then = new Date(timestamp)
  const diffMs = now - then
  const diffMins = Math.floor(diffMs / 60000)

  if (diffMins < 1) return 'Just now'
  if (diffMins < 60) return `${diffMins}m ago`

  const diffHours = Math.floor(diffMins / 60)
  if (diffHours < 24) return `${diffHours}h ago`

  const diffDays = Math.floor(diffHours / 24)
  return `${diffDays}d ago`
}

export function truncate(str, maxLen) {
  if (!str) return ''
  return str.length > maxLen ? str.substring(0, maxLen - 3) + '...' : str
}

export function formatTemplateKey(key) {
  const labels = {
    availability_missing: 'Availability Missing',
    response_needed: 'Response Needed',
    ready_no_proposal: 'Ready, No Proposal',
  }
  return labels[key] || key
}

export function getStatusBadgeColor(status) {
  const colors = {
    draft: 'secondary',
    sent: 'success',
    failed: 'danger',
    canceled: 'warning',
    test_sent: 'info',
    sending: 'primary',
  }
  return colors[status] || 'secondary'
}

export function getTemplateBadgeColor(templateKey) {
  const colors = {
    availability_missing: 'danger',
    response_needed: 'warning',
    ready_no_proposal: 'info',
  }
  return colors[templateKey] || 'secondary'
}

export function getTemplateDescription(key) {
  const descriptions = {
    availability_missing:
      "Reminder: Player hasn't marked when they're free to play this week. Email asks them to set their availability so they can be scheduled.",
    response_needed:
      "Action needed: Someone proposed a match to this player, but they haven't accepted or declined yet. Email prompts them to respond.",
    ready_no_proposal:
      "Good to go: Player is available but hasn't scheduled anything yet. Email encourages them to propose a match with an opponent.",
  }
  return descriptions[key] || ''
}

export function getCurrentCycleKey(date = new Date()) {
  const now = new Date(date)
  const dayNum = now.getDay() || 7
  now.setDate(now.getDate() + 4 - dayNum)

  const yearStart = new Date(now.getFullYear(), 0, 1)
  const weekNum = Math.ceil(((now - yearStart) / 86400000 + 1) / 7)

  return `${now.getFullYear()}-W${weekNum.toString().padStart(2, '0')}`
}
